/** 面交預購付款模式 */
export const PREORDER_PAYMENT_MODE = {
    ONLINE: 'online',
    PICKUP: 'pickup',
};
/** 面交取貨時付款的 orders.payment_method 值 */
export const PICKUP_DEFERRED_PAYMENT_METHOD = 'pickup_pay';
/** 逾時作廢／補建出貨時不應取消的未付款付款方式 */
export const DEFERRED_PAYMENT_METHODS = [
    'cvs_cod',
    PICKUP_DEFERRED_PAYMENT_METHOD,
];
